export enum CHECK_PROCESS_STATE_ENUMERATION {
  PENDING_SIGNATURE = 'PENDING_SIGNATURE',
  PENDING_REFERENCES = 'PENDING_REFERENCES',
  PENDING_DISPERSION_METHOD = 'PENDING_DISPERSION_METHOD',
  INVALID_PROCESS = 'INVALID_PROCESS',
}
